import { useHomepageAdsCapabilityCreativeData } from './useHomepageAdsCapabilityCreativeData';

export const HomepageArsCapabilityCreativeData = () => {
  useHomepageAdsCapabilityCreativeData();
  return null;
};
